import React from "react";
import commonObj from '../../../utils/Common';
import FloatingWhatsApp from "./FloatingWhatsApp";
import SettingModalLink from "./SettingModalLink";

const Footer = () => {
  return (
    <div className="p-5 w-full bg-red-800 flex flex-wrap items-center text-white footer-div-s absolute left-0 bottom-50 ">
      <p className="flex-1 text-center">{commonObj.getLabel('Buy_Sell_Made_Easy_Powered_by_Vstacks')}</p>

      <div className="flex gap-4 text-sm ml-auto">
        {/* <SettingModalLink
          label={commonObj.getLabel('Term_And_Condition')}
          settingKey="TERM_AND_CONDITION"
        /> */}
        <SettingModalLink
          label={commonObj.getLabel('Privacy_Policy')}
          settingKey="PRIVACYPOLICY"
        />
      </div>

      <FloatingWhatsApp phoneNumber="97688202020" message="сайн уу" />
    </div>
  );
};

export default Footer;
